import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { B2bRetirement, B2bRetirementRequest, ExportFinanceSummary, PcPosition } from '../interfaces/exportFinance.interface';

const E = ENDPOINTS.EXPORT_FINANCE;

/** Export finance (W3-B): packing-credit position, B2B acceptance retired by a loan, summary. Data only. */
export const ExportFinanceService = {
  retireB2bByLoan: async (body: B2bRetirementRequest): Promise<B2bRetirement> => (await axios.post(E.B2B_RETIREMENT, body)).data,
  pcPosition: async (institutionId: string, exportLcId: string): Promise<PcPosition> =>
    (await axios.get(E.PC_POSITION(institutionId), { params: { exportLcId } })).data,
  summary: async (institutionId: string): Promise<ExportFinanceSummary> => (await axios.get(E.SUMMARY(institutionId))).data,
};
